import { generateTemplatePublic } from '@/pages/api/scribeAPIV2';
import { type GenerateTemplatePublicResponse } from '@heidi/templates/contracts';
import { useMutation } from '@tanstack/react-query';

export const PUBLIC_TEMPLATE_GENERATION_MUTATION_KEY = [
  'public-template-generation',
] as const;

interface PublicTemplateGenerationParams {
  description: string;
  specialtyName?: string;
  country?: string;
  language?: string;
  fileContents?: string[];
}

export function useMutationPublicTemplateGeneration() {
  return useMutation<
    GenerateTemplatePublicResponse,
    Error,
    PublicTemplateGenerationParams
  >({
    mutationKey: PUBLIC_TEMPLATE_GENERATION_MUTATION_KEY,
    gcTime: 0,
    mutationFn: async ({
      description,
      specialtyName,
      country,
      language,
      fileContents,
    }) => {
      const { data } = await generateTemplatePublic({
        description,
        specialty_name: specialtyName,
        country,
        language,
        file_contents: fileContents,
      });
      return data;
    },
  });
}
